/* eslint-disable no-console */
import {
    MIGRATE_ADO_TO_GITHUB_DESCRIPTION,
    MIGRATE_GITHUB_TO_GITHUB_ENTERPRISE_DESCRIPTION,
    MIGRATE_EXISTING_OPTION,
    ONBOARDING_CATEGORY,
    GITHUB_ORGANIZATION,
    GITHUB_ORGANIZATION_NEW,
    COMMON,
    MAX_TEAM_MEMBERS,
    MAX_DEVOPS_TEAM_MEMBERS,
    SERVICE_ACCOUNT_EMAIL,
    MAX_CUSTOM_TEAM_REACHED_MSG,
    MAX_CUSTOM_TEAMS,
    MAX_MEMBER_REACHED_MSG,
    MAX_DEVOPS_MEMBER_REACHED_MSG,
    TEAM_SUFFIX_DEVELOPERS,
    TEAM_SUFFIX_DEVOPS,
    TEAM_TYPE,
    PIPELINE_SETUP_TYPE,
    TEAM_SUFFIX_READER,
} from './constant';

export const isReaderTeamName = (teamName = '') => {
    const normalized = (teamName || '').toLowerCase();
    return normalized.endsWith(`-${TEAM_SUFFIX_READER}`);
};

export const formOrderObjFromOrderDetails = (catalogServiceId, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog.catalogConfig || null;

    const groups = catalogConfig?.groups || [];

    const cwwGroup = groups.find((g) => g.groupName?.toLowerCase().includes('cwwuser'));
    const corpGroup = groups.find((g) => g.groupName?.toLowerCase().includes('corpuser'));

    const githubADGroupCWWMembers =
        cwwGroup?.members?.map((m) => ({
            gpid: m.gpid,
            name: m.name,
            email: m.email,
        })) || [];

    const githubADGroupCORPPVTMembers =
        corpGroup?.members?.map((m) => ({
            gpid: m.gpid,
            name: m.name,
            email: m.email,
        })) || [];

    const removedGithubADGroupCWWMembers =
        cwwGroup?.removedMembers?.map((m) => ({
            gpid: m?.gpid || m?.gpId || m || '',
            name: m?.name || '',
            email: m?.email || m?.emailId || '',
        })) || [];

    const removedGithubADGroupCORPPVTMembers =
        corpGroup?.removedMembers?.map((m) => ({
            gpid: m?.gpid || m?.gpId || m || '',
            name: m?.name || '',
            email: m?.email || m?.emailId || '',
        })) || [];

    const githubADGroupCORPPVTHasServiceAccount = Array.isArray(corpGroup?.serviceAccounts) && corpGroup?.serviceAccounts.length > 0 ? COMMON.YES : COMMON.NO;
    const githubADGroupCORPPVTServiceAccounts = Array.isArray(corpGroup?.serviceAccounts)
        ? corpGroup.serviceAccounts.map((serviceAccount) => ({ serviceAccount }))
        : [];

    const microservicesConfigs = (catalogConfig?.githubRepository || []).map((repo) => ({
        applicationType: repo.applicationType || null,
        templateLanguage: repo.language || null,
        templateLanguageDetails: null,
        templateBuildTool: repo.buildTool || '',
        templateFrameWork: repo.framework || '',
        templateName: repo.templateName || '',
        pipelineTemplateTechStack: repo.pipelineTemplateTechStack || null,
        applicationMicroserviceName: repo.microServiceName || '',
        newgithubRepositoryName: repo.githubRepositoryName || '',
        codeRepositoryStack: repo.codeRepositoryStack || '',
        isClone: false,
    }));

    const savedTeams = catalogConfig?.teams || [];
    const isReaderTeamRequired = savedTeams.some((t) => isReaderTeamName(t?.teamName)) ? COMMON.YES : COMMON.NO;

    const reposToMigrateList = catalogConfig?.repositoryToMigrate || [];
    const isADOMigration = catalogConfig?.platformType === MIGRATE_EXISTING_OPTION.ADO;
    let isMigratingADOPipelines = null;
    if (isADOMigration && reposToMigrateList?.length > 0) {
        isMigratingADOPipelines = reposToMigrateList?.some((r) => r?.pipelineIntegration) ? COMMON.YES : COMMON.NO;
    }

    // Derive isOnboardingPipelines from whether any githubRepository in the saved
    // payload carries a pipelineIntegration block (new onboarding flow only).
    const isNewOnboarding = catalogConfig?.onboardingType === ONBOARDING_CATEGORY.NEW;
    const githubRepoList = catalogConfig?.githubRepository || [];
    let isOnboardingPipelines = null;
    if (isNewOnboarding && githubRepoList.length > 0) {
        isOnboardingPipelines = githubRepoList.some((r) => r?.pipelineIntegration) ? COMMON.YES : COMMON.NO;
    }

    return {
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpId: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        registeredInSnow: catalogConfig?.snowRegistered === true ? COMMON.YES : COMMON.NO,
        sandboxPocDetails: catalogConfig?.sandboxPocDetails || {
            reasonForNotRegistering: null,
            purposeOfUsingSandbox: null,
            etaForRegistrationInMonths: null,
        },
        adoProjectName: catalogConfig?.adoProjectName,
        adoOrganization: catalogConfig?.adoOrganization,
        applicationService: catalogConfig?.applicationService,
        soxClassification: catalogConfig?.soxClassification ?? null,
        businessApplication: catalogConfig?.businessApplication,
        applicationSupportGroup: catalogConfig?.applicationSupportGroup || null,
        onboardingType: catalogConfig?.onboardingType,
        sector: catalogConfig?.sector,
        capability: catalogConfig?.capability,
        cmpHCode: catalogConfig?.budgetCode,
        portfolio: catalogConfig?.portfolio || null,
        isUsingAzureBoards: (catalogConfig?.onboardingType === ONBOARDING_CATEGORY.NEW && catalogConfig?.adoProjectName ? COMMON.YES : COMMON.NO) || null,
        isMigratingADO: catalogConfig?.platformType,
        isMigratingADOPipelines,
        isOnboardingPipelines,
        isReaderTeamRequired,
        githubOrgUnit: catalogConfig?.organizationUnit,
        environment: catalogConfig?.organizationUnit === GITHUB_ORGANIZATION ? COMMON.PRODUCTION : COMMON.SANDBOX_PERSONAL,
        githubADGroupCWWMembers,
        githubADGroupCORPPVTMembers,
        githubADGroupCORPPVTHasServiceAccount,
        githubADGroupCORPPVTServiceAccounts,
        removedGithubADGroupCWWMembers,
        removedGithubADGroupCORPPVTMembers,
        microservicesConfigs,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.applicationShortName || null,
    };
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: "GitHub license pricing is $13.71 per user per month. You'll only be charged for your primary team or group membership, so joining additional teams won't incur extra charges",
};

export const resetOrder = {
    appOwner: null,
    applicationName: null,
    appShortName: null,
    adoProjectName: null,
    adoOrganization: null,
    onboardingType: 'Migrate',
    applicationService: null,
    applicationServiceDetails: null,
    soxClassification: null,
    businessApplication: null,
    businessAppDetails: null,
    applicationSupportGroup: '',
    registeredInSnow: null,
    applicationMicroserviceName: '',
    sector: null,
    sectorDetail: null,
    capability: null,
    capabilityDetails: null,
    cmpHCode: null,
    portfolio: null,
    isUsingAzureBoards: COMMON.YES,
    isMigratingADO: 'ADO',
    isMigratingADOPipelines: null,
    isOnboardingPipelines: null,
    pipelineSetupType: null,
    isReaderTeamRequired: null,
    environment: null,
    githubOrgUnit: null,
    githubRepoName: '',
    githubRepo: null,
    githubRepoDetail: null,
    githubADGroupMember: null,
    githubADGroupMemberDetails: null,
    githubADGroupRemoveMember: null,
    githubADGroupRemoveMemberDetails: null,
    githubADGroupCWWMembers: [],
    githubADGroupCORPPVTMembers: [],
    githubADGroupCORPPVTHasServiceAccount: null,
    githubADGroupCORPPVTServiceAccounts: [],
    githubADGroupServiceAccount: null,
    removedGithubADGroupCWWMembers: [],
    removedGithubADGroupCORPPVTMembers: [],
    userAccessTeamMember: null,
    userAccessTeamMemberDetails: null,
    migrationConfirmation: false,
    microservicesConfigs: [
        {
            applicationType: null,
            templateLanguage: null,
            templateLanguageDetails: null,
            templateBuildTool: '',
            templateFrameWork: '',
            templateName: '',
            pipelineTemplateTechStack: null,
            applicationMicroserviceName: '',
            newgithubRepositoryName: '',
            codeRepositoryStack: '',
            isClone: false,
        },
    ],
    catalogCode: null,
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isSubmitOrderSuccess: false,
    isSubmitConfirmationOpen: false,
    isCostSplitOpen: false,
    isReposToMigrateOpen: false,
    isUserManagementOpen: false,
    isAssignReposOpen: false,
    isGithubADMembersOpen: false,
    isGithubADMembersRemoveOpen: false,
    isMicroServiceConfigOpen: false,
};

export const getGithubOrgUnit = (environment) => {
    if (!environment) return '';
    return environment === COMMON.PRODUCTION ? GITHUB_ORGANIZATION : GITHUB_ORGANIZATION_NEW;
};

// preview section helpers
export const getPreviewSectionInfo = (order, section) => {
    switch (section) {
        case 'general':
            return {
                ...(order?.applicationService && { 'Application Service': order.applicationService }),
                ...(order?.appOwner && { 'App Owner': order.appOwner }),
                ...(order?.applicationSupportGroup && { 'Application Support Group': order.applicationSupportGroup }),
                ...(order?.businessApplication && { 'Business Application': order.businessApplication }),
                ...(order?.applicationMicroserviceName && { 'Microservice Name': order.applicationMicroserviceName }),
                ...(order?.capability && { Capability: order.capability }),
                ...(order?.cmpHCode && { 'Cost Center': order.cmpHCode }),
                ...(order?.portfolio && { Portfolio: order.portfolio }),
                ...(order?.soxClassification !== null &&
                    order?.soxClassification !== undefined && {
                        'SOX Classification': order.soxClassification === true || order.soxClassification === 'true' ? 'Yes' : 'No',
                    }),
            };

        case 'project':
            return {
                ...(order?.onboardingType && { 'Onboarding Type': order.onboardingType }),
                ...(order?.adoProjectName && { 'ADO Project Name': order.adoProjectName }),
                ...(order?.adoOrganization && { 'ADO Organization': order.adoOrganization }),
                ...(order?.sector && { Sector: order.sector }),
                ...(order?.environment && { Environment: order.environment }),
                ...(order?.environment && { 'GitHub Organization  Unit': getGithubOrgUnit(order?.environment) }),
                ...(order?.isUsingAzureBoards !== null && {
                    'Do You Use Azure Boards for your project planning or backlog tracking ?': order.isUsingAzureBoards === COMMON.YES ? 'Yes' : 'No',
                }),
                ...(order?.registeredInSnow && {
                    'Do you have Business Application and Application CI registered in Snow?': order.registeredInSnow,
                }),
                ...(order?.registeredInSnow === COMMON.NO &&
                    order?.sandboxPocDetails?.reasonForNotRegistering && {
                        'Reason for Not Registering': order.sandboxPocDetails.reasonForNotRegistering,
                    }),
                ...(order?.registeredInSnow === COMMON.NO &&
                    order?.sandboxPocDetails?.purposeOfUsingSandbox && {
                        'Purpose of Using GitHub Enterprise Sandbox': order.sandboxPocDetails.purposeOfUsingSandbox,
                    }),
                ...(order?.registeredInSnow === COMMON.NO &&
                    (order?.sandboxPocDetails?.etaForRegistrationInMonths === 0 || order?.sandboxPocDetails?.etaForRegistrationInMonths) && {
                        'ETA for Registration in Months': order.sandboxPocDetails.etaForRegistrationInMonths,
                    }),
                ...(order?.isMigratingADO !== null &&
                    order.isMigratingADO === MIGRATE_EXISTING_OPTION.ADO &&
                    order?.onboardingType === ONBOARDING_CATEGORY.MIGRATE && {
                        'Migration from existing ADO to GitHub Enterprise Repository': MIGRATE_EXISTING_OPTION.ADO,
                    }),
                ...(order?.isMigratingADO !== null &&
                    order.isMigratingADO === MIGRATE_EXISTING_OPTION.GITHUB && {
                        'Migration from existing GitHub to GitHub Enterprise Repository': MIGRATE_EXISTING_OPTION.GITHUB,
                    }),
            };

        case 'preview-provision-general':
            return {
                ...(order?.businessApplication && { 'Business Application': order.businessApplication }),
                ...(order?.applicationService && { 'Application Service': order.applicationService }),
                ...(order?.applicationSupportGroup && { 'Application Support Group': order.applicationSupportGroup }),
                ...(order?.applicationManager && { 'Application Owner': order.applicationManager }),
                ...(order?.activeDirectoryGroupOwner && {
                    'Active Directory Group Owner': order.activeDirectoryGroupOwner,
                }),
                ...(order?.githubOwner && { 'GitHub Owner': order.githubOwner }),
                ...(order?.capability && { Capability: order.capability }),
                ...(order?.cmpHCode && { 'Cost Center': order.cmpHCode }),
                ...(order?.portfolio && { Portfolio: order.portfolio }),
            };

        default:
            return {};
    }
};

export const validateIsTouched = (isTouched) => {
    if (isTouched) return { color: '#d40020', fontWeight: 500 };
    return undefined;
};

// Teams related helpers

export const filterRemovedMembers = (membersList = [], removedMembersList = []) => {
    if (!removedMembersList.length) return membersList || [];

    const removedMemberGpIds = removedMembersList
        .map((removedMember) => {
            if (typeof removedMember === 'string') return removedMember;
            return removedMember?.gpId || removedMember?.gpid || removedMember?.login;
        })
        .filter(Boolean);

    return (membersList || []).filter((member) => {
        const memberGithubLogin = member?.githubUser || member?.login || '';
        const memberGpId = memberGithubLogin.includes('_') ? memberGithubLogin.split('_')[0] : memberGithubLogin;

        return !removedMemberGpIds.includes(memberGpId);
    });
};

export const sanitizeBusinessApplicationName = (name) => {
    if (!name || typeof name !== 'string') return '';

    return name.replace(/[^a-z0-9]/gi, '').toLowerCase();
};

export const normalizeReaderTeamName = (teamName = '') => {
    const value = (teamName || '').trim();
    if (!value) return value;
    return value.replace(/-reader(s)?$/i, `-${TEAM_SUFFIX_READER}`);
};

export const sanitizeCapabilityName = (capability) => {
    if (!capability || typeof capability !== 'string') return '';

    return capability
        .replace(/&/g, '') // remove ampersands
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .toLowerCase();
};

export const getCustomTeamNameParts = (teamName, businessApplication) => {
    if (!teamName || !businessApplication) return {};

    const sanitizedAppName = sanitizeBusinessApplicationName(businessApplication);
    if (!sanitizedAppName) return {};

    const [capability, ...rest] = teamName.split('-');
    if (!capability || !rest.length) return {};

    const categorization = rest[rest.length - 1] || TEAM_SUFFIX_DEVELOPERS;
    const coreSegments = rest.slice(0, -1);

    if (!coreSegments.length) return {};

    let collected = '';
    let appSegmentsEndIndex = -1;

    for (let index = 0; index < coreSegments.length; index += 1) {
        collected = collected ? `${collected}-${coreSegments[index]}` : coreSegments[index];

        if (sanitizeBusinessApplicationName(collected) === sanitizedAppName) {
            appSegmentsEndIndex = index;
            break;
        }
    }

    if (appSegmentsEndIndex === -1) return {};

    const customName = coreSegments.slice(appSegmentsEndIndex + 1).join('-');

    return { capability, appName: sanitizedAppName, customName, categorization };
};

export const updateTeamNames = (teams, capability, capabilityDetails, businessApplication) => {
    if (!(capabilityDetails?.value || capability) || !businessApplication) return teams;

    const capabilityName = capabilityDetails?.value.toLowerCase() || capability;
    const baseName = `${sanitizeCapabilityName(capabilityName)}-${sanitizeBusinessApplicationName(businessApplication)}`;

    return teams.map((team) => {
        if (team.isDefault) {
            if (team.name.includes(TEAM_SUFFIX_DEVELOPERS)) {
                return { ...team, name: `${baseName}-${TEAM_SUFFIX_DEVELOPERS}` };
            }
            if (team.name.includes(TEAM_SUFFIX_DEVOPS)) {
                return { ...team, name: `${baseName}-${TEAM_SUFFIX_DEVOPS}` };
            }
            if (isReaderTeamName(team.name)) {
                return { ...team, name: `${baseName}-${TEAM_SUFFIX_READER}` };
            }
        }
        return team;
    });
};

export const syncCustomTeamName = (team, order) => {
    if (team.isDefault) return team;

    const capability = sanitizeCapabilityName(order?.capabilityDetails?.value || team.capability);
    const appName = sanitizeBusinessApplicationName(order?.businessApplication ?? team.appName ?? '');

    const updated = {
        ...team,
        capability,
        appName,
        customName: team.customName || '',
        categorization: team.categorization || TEAM_SUFFIX_DEVELOPERS,
    };

    updated.name = [updated.capability, updated.appName, updated.customName, updated.categorization].join('-');
    return updated;
};

export const getDefaultTeams = (capability, capabilityDetails, businessApplication, isReaderTeamRequired = null) => {
    if (!(capabilityDetails?.value || capability) || !businessApplication) return [];
    const capabilityName = capabilityDetails?.value.toLowerCase() || capability;

    const baseName = `${sanitizeCapabilityName(capabilityName)}-${sanitizeBusinessApplicationName(businessApplication)}`;

    const teams = [];

    // Add reader team FIRST if required
    if (isReaderTeamRequired === COMMON.YES) {
        teams.push({
            isDefault: true,
            name: `${baseName}-${TEAM_SUFFIX_READER}`,
            members: [],
            originalMembers: [],
            removedMembers: [],
            existingOrgMembers: [],
            repos: [],
            originalRepos: [],
            hasExistingMembers: false,
            teamExistsInOrg: false,
        });
    }

    // Then add developers team
    teams.push({
        isDefault: true,
        name: `${baseName}-${TEAM_SUFFIX_DEVELOPERS}`,
        members: [],
        originalMembers: [],
        removedMembers: [],
        existingOrgMembers: [],
        repos: [],
        originalRepos: [],
        hasExistingMembers: false,
        teamExistsInOrg: false,
    });

    // Then add devops team
    teams.push({
        isDefault: true,
        name: `${baseName}-devops`,
        members: [],
        originalMembers: [],
        removedMembers: [],
        existingOrgMembers: [],
        repos: [],
        originalRepos: [],
        hasExistingMembers: false,
        teamExistsInOrg: false,
    });

    return teams;
};

export const getTeamMemberDiffs = (team = {}) => {
    const { members = [], originalMembers = [] } = team;

    const currentLogins = members.map((m) => m.login);
    const originalLogins = originalMembers.map((m) => m.login);

    const membersAdded = members.filter((m) => !originalLogins.includes(m.login));
    const membersRemoved = originalMembers.filter((m) => !currentLogins.includes(m.login));

    return { membersAdded, membersRemoved };
};

export const getOppositeTeamInfo = (teams, currentIndex, gpid) => {
    const currentTeamName = teams[currentIndex]?.name?.toLowerCase();

    // each suffix is mutually exclusive with all others listed
    const restrictedSuffixMap = {
        [TEAM_SUFFIX_DEVELOPERS]: [TEAM_SUFFIX_DEVOPS, TEAM_SUFFIX_READER],
        [TEAM_SUFFIX_DEVOPS]: [TEAM_SUFFIX_DEVELOPERS, TEAM_SUFFIX_READER],
        [TEAM_SUFFIX_READER]: [TEAM_SUFFIX_DEVELOPERS, TEAM_SUFFIX_DEVOPS],
    };

    // find the suffix of the current team name that is in the restrictedSuffixMap
    const matchedSuffix = Object.keys(restrictedSuffixMap).find((suffix) => currentTeamName?.endsWith(suffix));
    if (!matchedSuffix) return { exists: false, oppositeName: null };

    // check if any other team has a name that ends with one of the restricted suffixes and contains the same gpid in its members
    const conflictingSuffix = restrictedSuffixMap[matchedSuffix].find((restrictedSuffix) => {
        const restrictedTeams = teams.filter((team, i) => i !== currentIndex && team.name?.toLowerCase().endsWith(restrictedSuffix));
        return restrictedTeams.some((team) => {
            const allMembers = [...(team.members || []), ...(team.existingOrgMembers || [])];
            return allMembers.some((member) => member.login?.split('_')[0] === gpid || member.githubUser?.split('_')[0] === gpid);
        });
    });

    // if a conflicting suffix is found, return the first team name that has that suffix
    return conflictingSuffix ? { exists: true, oppositeName: conflictingSuffix } : { exists: false, oppositeName: null };
};

export const getGithubOnboardingRequestUrl = (baseUrl, additionalParams = {}) => {
    const org = process.env.REACT_APP_GITHUB_ONBOARDING_ORG;

    const params = new URLSearchParams({ org, ...additionalParams });

    return `${baseUrl}?${params.toString()}`;
};

export const extractGithubNames = (isADO, reposToMigrate) => reposToMigrate.map((repo) => (isADO ? repo.githubName : repo.githubEnterpriseName));
export const extractNewGithubRepositoryNames = (order) => order?.microservicesConfigs?.map((config) => config?.newgithubRepositoryName);

const sanitizeRepositoryName = (value) => (typeof value === 'string' ? value.trim() : '');

export const getJfrogTargetRepositories = ({ order = {}, reposToMigrateList = [] }) => {
    const onboardingType = order?.onboardingType;

    if (onboardingType === ONBOARDING_CATEGORY.NEW) {
        const repositories = Array.isArray(order?.microservicesConfigs)
            ? order.microservicesConfigs.map((config) => sanitizeRepositoryName(config?.newgithubRepositoryName)).filter(Boolean)
            : [];

        return [...new Set(repositories)];
    }

    if (onboardingType === ONBOARDING_CATEGORY.MIGRATE) {
        const repositories = Array.isArray(reposToMigrateList)
            ? reposToMigrateList
                  .map((repo) => {
                      if (order?.isMigratingADO === MIGRATE_EXISTING_OPTION.GITHUB) {
                          return sanitizeRepositoryName(repo?.githubEnterpriseName || repo?.githubName);
                      }
                      return sanitizeRepositoryName(repo?.githubName || repo?.adoName);
                  })
                  .filter(Boolean)
            : [];

        return [...new Set(repositories)];
    }

    return [];
};

export const convertRepoName = (capability, adoRepoName) => `${capability.toLowerCase()}-${adoRepoName.replace(/_/g, '-')}`;

export const reposLimit = 5;

export const assignReposToTeams = (teams, teamsAndAssignedRepos) => {
    const defaultRepos = teamsAndAssignedRepos.find((team) => team.isDefault)?.repos || [];

    return teams.map((team) => {
        if (team.isDefault) {
            return {
                ...team,
                repos: defaultRepos,
                originalRepos: defaultRepos,
            };
        }

        const matchedTeam = teamsAndAssignedRepos.find((t) => !t.isDefault && t.name?.toLowerCase() === team.name?.toLowerCase());

        const updatedRepos = matchedTeam?.repos || [];

        const cleanedOriginalRepos = (matchedTeam?.originalRepos || []).filter((repo) => updatedRepos.includes(repo));

        return {
            ...team,
            repos: updatedRepos,
            originalRepos: cleanedOriginalRepos,
        };
    });
};

export const checkIfAllReposAssigned = (teams, allRepos) => {
    const validRepos = allRepos.filter(Boolean);

    if (!validRepos.length) return true;

    const assignedRepos = teams.flatMap((team) => team.repos);
    const assignedSet = new Set(assignedRepos);

    return validRepos.every((repo) => assignedSet.has(repo));
};

export const splitTeams = (teams = []) => {
    const customTeams = teams.filter((team) => !team.isDefault);
    const defaultTeam = teams.find((team) => team.isDefault);

    return { customTeams, defaultTeam };
};

export const getTeamMemberLimit = (teamName, existingOrgMembers = []) => {
    const lowerName = (teamName || '').toLowerCase();

    // Developers team: has no limit
    if (lowerName.endsWith(TEAM_SUFFIX_DEVELOPERS)) {
        return null;
    }

    // DevOps team: 5 by default, 6 if a service account (svcGitHubEnt@pepsico.com) is present
    if (lowerName.endsWith(TEAM_SUFFIX_DEVOPS)) {
        const hasServiceAccount = existingOrgMembers.some((m) => m.email === SERVICE_ACCOUNT_EMAIL);
        return hasServiceAccount ? MAX_TEAM_MEMBERS : MAX_DEVOPS_TEAM_MEMBERS;
    }

    // Default: max 6
    return MAX_TEAM_MEMBERS;
};

export const checkMemberLimit = (members, existingOrgMembers = [], teamName = '') => {
    const totalMembers = (members?.length || 0) + (existingOrgMembers?.length || 0);
    const limit = getTeamMemberLimit(teamName, existingOrgMembers);

    if (limit === null) {
        return { allowed: true, message: '' };
    }
    if (totalMembers >= limit) {
        const message = limit === MAX_DEVOPS_TEAM_MEMBERS ? MAX_DEVOPS_MEMBER_REACHED_MSG : MAX_MEMBER_REACHED_MSG;
        return { allowed: false, message };
    }
    return { allowed: true, message: '' };
};

export const checkCustomTeamLimit = (customTeams) => {
    if (customTeams.length >= MAX_CUSTOM_TEAMS) {
        return {
            allowed: false,
            message: MAX_CUSTOM_TEAM_REACHED_MSG,
        };
    }
    return { allowed: true, message: '' };
};

export const resolveMemberName = (member) => {
    if (!member) return '';
    const { name, displayName, firstName, lastName, email, gpid } = member;
    if (name) {
        return name;
    }
    if (displayName) {
        return displayName;
    }
    const composedName = [firstName, lastName].filter(Boolean).join(' ').trim();
    if (composedName) {
        return composedName;
    }
    return email || gpid || '';
};

// microservice config helpers
export const findDuplicateMicroserviceConfigs = (array) => {
    const duplicates = new Map();

    const cleanedArray = array?.map((item) => {
        const newItem = { ...item };
        delete newItem.isClone;
        return newItem;
    });

    const microserviceNameMap = new Map();
    cleanedArray?.forEach((item, index) => {
        const microserviceName = item?.applicationMicroserviceName?.trim()?.toLowerCase();
        if (microserviceName) {
            if (microserviceNameMap.has(microserviceName)) {
                const key = JSON.stringify({ applicationMicroserviceName: item?.applicationMicroserviceName || '' });
                if (duplicates.has(key)) {
                    duplicates.get(key).push(index);
                } else {
                    duplicates.set(key, [microserviceNameMap.get(microserviceName), index]);
                }
            } else {
                microserviceNameMap.set(microserviceName, index);
            }
        }
    });

    const repoNameMap = new Map();
    cleanedArray?.forEach((item, index) => {
        const repoName = item?.newgithubRepositoryName?.trim()?.toLowerCase();
        if (repoName) {
            if (repoNameMap.has(repoName)) {
                const key = JSON.stringify({ newgithubRepositoryName: item?.newgithubRepositoryName || '' });
                if (duplicates.has(key)) {
                    if (!duplicates.get(key).includes(index)) {
                        duplicates.get(key).push(index);
                    }
                } else {
                    const firstIndex = repoNameMap.get(repoName);
                    if (!Array.from(duplicates.values()).flat().includes(firstIndex)) {
                        duplicates.set(key, [firstIndex, index]);
                    } else {
                        duplicates.set(key, [firstIndex, index]);
                    }
                }
            } else {
                repoNameMap.set(repoName, index);
            }
        }
    });

    return duplicates;
};

export const getCombinedDuplicateMicroserviceIndexes = (array) => {
    const duplicates = findDuplicateMicroserviceConfigs(array);
    const allDuplicateIndexes = new Set();
    duplicates.forEach((indexes) => {
        indexes.forEach((idx) => allDuplicateIndexes.add(idx));
    });
    return Array.from(allDuplicateIndexes);
};

// payload builders

export const getGroupsPayload = (order) => {
    const cwwGroup = {
        groupType: 'Active Directory Group', // static
        isPrivileged: false, // static
        groupName: 'team.app.github.global.cwwuser', // static
        groupOwner: '81188952', // static
    };

    const cwwMembers = Array.isArray(order?.githubADGroupCWWMembers) ? order.githubADGroupCWWMembers.map((m) => m.gpid) : [];
    if (cwwMembers.length > 0) {
        cwwGroup.members = cwwMembers;
    }

    const cwwRemovedMembers = Array.isArray(order?.removedGithubADGroupCWWMembers) ? order.removedGithubADGroupCWWMembers.map((m) => m.gpid) : [];
    if (cwwRemovedMembers.length > 0) {
        cwwGroup.removedMembers = cwwRemovedMembers;
    }

    const corpGroup = {
        groupType: 'Active Directory Group', // static
        isPrivileged: false, // static
        groupName: 'team.app.github.global.corpuser', // static
        groupOwner: '81188952', // static
    };

    const corpMembers = Array.isArray(order?.githubADGroupCORPPVTMembers) ? order.githubADGroupCORPPVTMembers.map((m) => m.gpid) : [];
    if (corpMembers.length > 0) {
        corpGroup.members = corpMembers;
    }

    const corpRemovedMembers = Array.isArray(order?.removedGithubADGroupCORPPVTMembers) ? order.removedGithubADGroupCORPPVTMembers.map((m) => m.gpid) : [];
    if (corpRemovedMembers.length > 0) {
        corpGroup.removedMembers = corpRemovedMembers;
    }

    const corpServiceAccounts = Array.isArray(order?.githubADGroupCORPPVTServiceAccounts)
        ? order.githubADGroupCORPPVTServiceAccounts.map((sa) => sa.serviceAccount)
        : [];
    if (corpServiceAccounts.length > 0) {
        corpGroup.serviceAccounts = corpServiceAccounts;
    }

    const groups = [cwwGroup, corpGroup];

    return groups.filter((g) => g.members || g.removedMembers || g.serviceAccounts);
};

export const getTeamsPayload = (teams) => {
    if (!Array.isArray(teams)) return [];
    return teams.map((team) => {
        const payload = {
            teamName: team?.name,
            type: team?.isDefault ? TEAM_TYPE.DEFAULT : TEAM_TYPE.CUSTOM,
            repos: Array.isArray(team?.repos) ? team.repos : [],
        };

        // Only include members key if there are members to add
        if (Array.isArray(team?.members) && team.members.length > 0) {
            payload.members = team.members.map((member) => ({
                name: member?.name,
                gpId: member?.gpid || member?.login,
                emailId: member?.email,
                ...(member?.hasCopilotLicense !== null && member?.hasCopilotLicense !== undefined && { coPilotLicense: member?.hasCopilotLicense }),
                ...(member?.isPartOfBaseAdGroups !== null &&
                    member?.isPartOfBaseAdGroups !== undefined && { isPartOfBaseAdGroups: member?.isPartOfBaseAdGroups }),
            }));
        }

        // Include removedMembers only when present and non-empty
        if (Array.isArray(team?.removedMembers) && team.removedMembers.length > 0) {
            payload.removedMembers = team.removedMembers.map((rm) => {
                if (typeof rm === 'string') {
                    return { name: '', gpId: rm, emailId: '' };
                }
                return {
                    name: rm?.name || '',
                    gpId: rm?.gpId || rm?.gpid || rm?.login || '',
                    emailId: rm?.emailId || rm?.email || '',
                    ...(rm?.hasCopilotLicense !== null && rm?.hasCopilotLicense !== undefined && { coPilotLicense: rm?.hasCopilotLicense }),
                    ...(rm?.isPartOfBaseAdGroups !== null && rm?.isPartOfBaseAdGroups !== undefined && { isPartOfBaseAdGroups: rm?.isPartOfBaseAdGroups }),
                };
            });
        }

        return payload;
    });
};

export const getReposToMigratePayload = (order, reposToMigrate = [], sonarQubeConfig = {}) => {
    if (!Array.isArray(reposToMigrate)) return [];

    const getSonarQubeInfo = (repositoryName) => {
        const sonarInfo = {};

        // Check if SonarQube integration is enabled and repo is onboarded
        if (sonarQubeConfig?.requiresIntegration === COMMON.YES && sonarQubeConfig?.validationData?.results) {
            const repoInSonar = sonarQubeConfig.validationData.results.find(
                (repo) => repo.repositoryName === repositoryName && repo?.availableInSonar === true
            );

            if (repoInSonar) {
                sonarInfo.sonarQubeOnboarded = true;
                const sonarQubeProjectKey = `${order?.adoProjectName}-${repositoryName}`;
                sonarInfo.sonarQubeProjectKey = sonarQubeProjectKey;

                // Check if user wants to modify the project name
                if (sonarQubeConfig?.shouldModifyProjectName === COMMON.YES && sonarQubeConfig?.modifiedSonarProjects?.length > 0) {
                    const modifiedProject = sonarQubeConfig.modifiedSonarProjects.find((project) => project.existingProjectName === sonarQubeProjectKey);

                    if (modifiedProject && modifiedProject.newProjectName) {
                        sonarInfo.updatedSonarQubeProjectKey = modifiedProject.newProjectName;
                    }
                }
                // If shouldModifyProjectName is NO, we don't add updatedSonarQubeProjectKey - just keep the existing key
            } else {
                sonarInfo.sonarQubeOnboarded = false;
            }
        }

        return sonarInfo;
    };

    if (order?.onboardingType === ONBOARDING_CATEGORY.MIGRATE && order?.isMigratingADO !== MIGRATE_EXISTING_OPTION.GITHUB) {
        return reposToMigrate.map((item) => ({
            sourceRepositoryName: item?.adoName,
            targetRepositoryName: item?.githubName,
            ...getSonarQubeInfo(item?.adoName),
        }));
    }

    return reposToMigrate.map((item) => ({
        sourceRepositoryName: item?.githubName,
        targetRepositoryName: item?.githubEnterpriseName,
        ...getSonarQubeInfo(item?.githubName),
    }));
};

export const generateSonarQubeValidationPayload = ({ onboardingType, adoProjectName, repositoryNames, organizationUnit }) => {
    if (!repositoryNames || repositoryNames.length === 0) {
        return null;
    }

    if (onboardingType === ONBOARDING_CATEGORY.MIGRATE) {
        return {
            onboardingType: ONBOARDING_CATEGORY.MIGRATE,
            projectName: adoProjectName || '',
            repositoryNames,
            organizationUnit,
        };
    }

    if (onboardingType === ONBOARDING_CATEGORY.NEW) {
        return {
            onboardingType: ONBOARDING_CATEGORY.NEW,
            repositoryNames,
            organizationUnit,
        };
    }

    return null;
};

/**
 * Helper function to check if tech stack is "None"
 * @param {string} techStack - The tech stack value to check
 * @returns {boolean} - True if tech stack is "None"
 */
export const isNoneTechStack = (techStack) => {
    return techStack === COMMON.NONE || techStack === 'None';
};

export const buildPipelineIntegrationPayload = (pipelineData) => {
    if (!pipelineData) return null;

    // When tech stack is "None", include only the basic fields plus selected variable groups.
    if (pipelineData.selectedTechStack && isNoneTechStack(pipelineData.selectedTechStack)) {
        const pipelineIntegration = {};
        if (pipelineData.pipelineType) {
            pipelineIntegration.pipelineType = pipelineData.pipelineType;
        }
        pipelineIntegration.techStack = pipelineData.selectedTechStack;
        if (Array.isArray(pipelineData.variableGroupNames) && pipelineData.variableGroupNames.length > 0) {
            pipelineIntegration.variableGroupNames = pipelineData.variableGroupNames;
        }
        return Object.keys(pipelineIntegration).length > 0 ? pipelineIntegration : null;
    }

    const pipelineKeys = ['pipelineType', 'deployMechanism', 'branchingStrategy', 'globalTemplate', 'githubCataloguePath', 'buildPattern', 'deploymentPattern'];
    const pipelineIntegration = {};
    pipelineKeys.forEach((key) => {
        if (pipelineData[key] !== undefined && pipelineData[key] !== null && pipelineData[key] !== '') {
            pipelineIntegration[key] = pipelineData[key];
        }
    });
    // Map selectedTechStack (string the user resolved) back to techStack for the backend
    if (pipelineData.selectedTechStack) {
        pipelineIntegration.techStack = pipelineData.selectedTechStack;
    }
    if (Array.isArray(pipelineData.variableGroupNames) && pipelineData.variableGroupNames.length > 0) {
        pipelineIntegration.variableGroupNames = pipelineData.variableGroupNames;
    }
    if (Array.isArray(pipelineData.multiRegion) && pipelineData.multiRegion.length > 0) {
        pipelineIntegration.multiRegion = pipelineData.multiRegion;
    }
    if (Array.isArray(pipelineData.multiModule) && pipelineData.multiModule.length > 0) {
        pipelineIntegration.multiModule = pipelineData.multiModule;
    }
    return Object.keys(pipelineIntegration)?.length > 0 ? pipelineIntegration : null;
};

export const buildNewOnboardingPipelinePayload = (pipelineConfig) => {
    if (!pipelineConfig?.globalTemplate) return null;
    const isBuild = !pipelineConfig?.deploymentMechanism;
    return {
        pipelineSetup: isBuild ? PIPELINE_SETUP_TYPE.BUILD : PIPELINE_SETUP_TYPE.BUILD_AND_DEPLOYMENT,
        ...(pipelineConfig.globalTemplate && { globalTemplate: pipelineConfig.globalTemplate }),
        ...(pipelineConfig.cataloguePath && { githubCataloguePath: pipelineConfig.cataloguePath }),
        ...(pipelineConfig.buildPattern && { buildPattern: pipelineConfig.buildPattern }),
        ...(!isBuild && {
            ...(pipelineConfig.deploymentMechanism && { deployMechanism: pipelineConfig.deploymentMechanism }),
            ...(pipelineConfig.branchingStrategy && { branchingStrategy: pipelineConfig.branchingStrategy }),
            ...(pipelineConfig.deploymentPattern && { deploymentPattern: pipelineConfig.deploymentPattern }),
        }),
    };
};

export const buildJfrogResolvePayload = ({ isMigrationFlow, resolveRepos, order, reposToMigrateList }) => {
    if (isMigrationFlow) {
        const repoNames = resolveRepos.map((repositoryName) => {
            const migrateRepo = reposToMigrateList?.find((r) => r?.githubName === repositoryName || r?.githubEnterpriseName === repositoryName);
            return migrateRepo?.adoName || repositoryName;
        });
        return {
            scenario: 'Migration',
            adoOrganization: order?.adoOrganization,
            adoProjectName: order?.adoProjectName,
            repoNames,
        };
    }

    const onboardingItems = [];
    const seen = new Set();
    resolveRepos.forEach((repositoryName) => {
        const ms = order?.microservicesConfigs?.find((m) => m?.newgithubRepositoryName === repositoryName);
        if (ms?.templateLanguage && ms?.templateBuildTool) {
            const key = `${ms.templateLanguage}|${ms.templateBuildTool}`;
            if (!seen.has(key)) {
                seen.add(key);
                onboardingItems.push({ language: ms.templateLanguage, buildTool: ms.templateBuildTool });
            }
        }
    });
    return { scenario: 'Onboarding', onboardingItems };
};

// other helpers

// eslint-disable-next-line consistent-return
export const getDescriptionLabel = (onboardingType) => {
    if (onboardingType === MIGRATE_EXISTING_OPTION.ADO) return MIGRATE_ADO_TO_GITHUB_DESCRIPTION;
    if (onboardingType === MIGRATE_EXISTING_OPTION.GITHUB) return MIGRATE_GITHUB_TO_GITHUB_ENTERPRISE_DESCRIPTION;
    return MIGRATE_ADO_TO_GITHUB_DESCRIPTION;
};

export const getModalTitle = (isOpen) => {
    if (isOpen?.isReposToMigrateOpen) return 'Migrate application repos';
    if (isOpen?.isUserManagementOpen) return 'User access management';
    if (isOpen?.isAssignReposOpen) return 'Repo access control';
    if (isOpen?.isGithubADMembersOpen) return 'GitHub Active Directory Group Membership';
    if (isOpen?.isGithubADMembersRemoveOpen) return 'GitHub Members Removal';
    return null;
};

export const formatDateTime = (isoString) => {
    if (!isoString) return '';
    try {
        return new Date(isoString).toLocaleString();
    } catch {
        return isoString;
    }
};

/**
 * Calculate duration between two ISO date-time strings and format it.
 * @param {string} startTime - ISO string (e.g. "2025-11-22T17:11:11.4523347")
 * @param {string} endTime - ISO string (e.g. "2025-11-22T17:11:19.4014785")
 * @returns {object} duration - { milliseconds, seconds, minutes, formatted }
 */
export function calculateDuration(startTime, endTime) {
    if (!startTime || !endTime) return null;

    const start = new Date(startTime);
    const end = new Date(endTime);

    const diffMs = end.getTime() - start.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);

    let formatted = '';
    if (diffHr > 0) formatted += `${diffHr} hour${diffHr > 1 ? 's' : ''} `;
    if (diffMin % 60 > 0) formatted += `${diffMin % 60} minute${diffMin % 60 > 1 ? 's' : ''} `;
    if (diffSec % 60 > 0 || formatted === '') {
        formatted += `${diffSec % 60} second${diffSec % 60 !== 1 ? 's' : ''}`;
    }

    return {
        milliseconds: diffMs,
        seconds: diffSec,
        minutes: diffMin,
        formatted: formatted.trim(),
    };
}

export const formatStatus = (status = '') => status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
